module.exports = __webpack_public_path__ + "static/assets/b74faacb619dad0b5f3871a04a6bcd0e.mp3";